export default theme => ({
  topbar: {
    position: 'fixed',
    width: '100%',
    top: 0,
    left: 0,
    right: 'auto',
    transition: theme.transitions.create(['margin', 'width'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen
    })
  },
  topbarShift: {
    marginLeft: '271px',
    width: 'calc(-271px + 100vw)'
  },
  drawerPaper: {
    zIndex: 2500,
    width: '271px',
    position: 'fixed',
    top: 0,
    height: '100vh',
    backgroundColor: theme.palette.background.default,
  },
  sidebar: {
    width: '255px'
  },
  content: {
    marginTop: '64px',
    // minHeight paired with marginTop: '64px' above must add up to one viewport,
    // not one viewport ON TOP OF the 64px offset - '100vh' here guaranteed at
    // least 64px of extra scroll below the fold on any page shorter than
    // 100vh + 64px (e.g. Home's single-viewport hero).
    minHeight: 'calc(100vh - 64px)',
    backgroundColor: theme.palette.background.default,
    transition: theme.transitions.create('margin', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen
    })
  },
  contentWithoutMargin: {
    marginTop: '0px',
    minHeight: '100vh',
    backgroundColor: theme.palette.background.default,
    transition: theme.transitions.create('margin', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen
    })
  },
});
